/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { appConfig } from '@/AppConfig';
import React, { useEffect } from 'react';

const IntercomWidget = () => {
  useEffect(() => {
    if (appConfig?.intercom?.appId) {
      window.intercomSettings = {
        app_id: appConfig.intercom.appId,
        api_base: 'https://api-iam.intercom.io'
      };

      const script = document.createElement('script');
      script.src = `https://widget.intercom.io/widget/${window.intercomSettings.app_id}`;
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
    return () => {};
  }, []);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
};

export default IntercomWidget;
